import { searchTerms } from "./../app";
import { trans } from "./trans";
import { notify } from "./notify";
import { request } from "./request";
import { initializeReleaseSearch } from "./initializeReleaseSearch";
import { searchYear, searchTag, lang, status } from "./../app";

export const buildFilter = async (tags, parent, userLevel) => {
	parent.html(`<form id="release_search" uk-grid class="uk-grid-row-collapse uk-grid-column-small uk-flex uk-flex-center uk-flex-bottom">
                <div class="uk-margin-small-bottom uk-padding-remove uk-width-1-1 uk-width-1-4@s">
                    <label for="filter_categories" class="uk-legend filter_label">${trans("Filter by")}</label>
                    <select id="filter_categories" name="tag" class="filter_input uk-select">
                        <option></option>    
                    </select>
                </div>
                <div class="uk-margin-small-bottom uk-width-1-1 uk-width-1-6@s">
                    <label for="filter_year" class="uk-legend filter_label">${trans("Year")}</label>
                    <select id="filter_year" name="year" class="filter_input uk-select">
                        <option></option>
                    </select>
                </div>
                <div class="uk-margin-small-bottom uk-width-1-1 uk-width-1-4@s">
                    <label for="terms" class="uk-legend filter_label">${trans("Keywords")} (enclose phrases in quotes)</label>
                    <input id="terms" name="terms" value="${searchTerms ? searchTerms.map(term => (term.split(" ").length > 1 ? `'${term}'` : term)).join(" ") : ""}" class="filter_input uk-input">					
                </div>
                <div class="uk-margin-small-bottom uk-width-1-1 uk-width-1-4@s uk-flex uk-flex-between">
                    <div id="submit_button" class="uk-width-1-2 uk-flex uk-flex-left">
                        <button class="uk-button-primary uk-button-small uk-position-relative" type="submit">${trans("Search")}</button>
                    </div>
                    <div id="clear_form_button" class="uk-width-1-2 uk-flex uk-flex-right">
                        <button class="uk-button-primary uk-button-small">${trans("Clear")}</button>
                    </div>
                </div>
				${
					userLevel === "admin"
						? `<div class="uk-margin-small-bottom uk-width-1-1 uk-text-center">
					<label for="dark_items">Include only "Dark" items <input type="checkbox" class="uk-checkbox" id="dark_items" value="true" name="dark_items"/></label>
				</div>`
						: ""
				}
            </form>`);

	let end = 2000;
	let start = new Date().getFullYear();
	for (let i = start; i > end - 1; i--) {
		$("#filter_year").append(`<option value="${i}">${i}</option>`);
	}
	// add year options

	let selectOptions = {
		dropdownParent: "#filter_wrapper",
		width: "100%",
		tags: false,
		allowClear: false
	};
	let yearSelect = $("select[name='year']").select2(selectOptions);
	if (searchYear) {
		yearSelect.val(searchYear);
		yearSelect.trigger("change");
	}
	// year select init

	let tagSelect = $("#filter_categories");
	try {
		const response = await request({
			reqId: "fcc1be2a-3c7f-464c-b471-21817032c8b2",
			type: "tagList",
			id: "tagList"
		});
		tags = Object.assign(tags, response.tags);
		tags[lang].sort().forEach(tag => {
			tagSelect.append(`<option value="${tag}">${tag}</option>`);
		});
		tagSelect.select2(selectOptions);
		if (searchTag) {
			tagSelect.val(searchTag);
			tagSelect.trigger("change");
		}
	} catch (err) {
		tags = { [lang]: [] };
		tagSelect.append(`<option value=""></option>`).select2(selectOptions);
		notify(trans("There was an error retrieving categories."), "danger", "top-left", 3000, "tags");
	}
	// tag select init (using same options as year select)

	setTimeout(() => {
		let arrowWrapper = $(".select2-selection__arrow");
		arrowWrapper.each(function () {
			$(this).append(`<span class="select_arrow" uk-icon="icon: chevron-down"></span>`);
		});
	}, 500);
	// add uikit chevron dropdown arrows

	$("#release_search select")
		.on("select2:opening", function () {
			$(this).siblings(".select2-container").find(".select_arrow").attr("uk-icon", "icon: chevron-up");
		})
		.on("select2:closing", function () {
			$(this).siblings(".select2-container").find(".select_arrow").attr("uk-icon", "icon: chevron-down");
		});
	// opening/closing listeners to orient chevrons

	$("#clear_form_button").on("click", function (e) {
		e.preventDefault();
		$("#release_search input").val("");
		$("#release_search select").val(null).trigger("change");
	});
	// clear form button click handler

	initializeReleaseSearch();
	// we wait until now to initialize search
	// form because a) it needs to exist and
	// b) we need to know who our user is
};
// end buildFilter function
